export const roleMap = Object.freeze({
   technicalUnit: "268d8c1d-af9f-46fe-8843-8a66ca611504",
   seniorPastor: "3a13d88e-939c-4477-8f56-25c1e44bd2fd",
   residentPastor: "3c5785ec-29a8-4186-a0f4-9d74a593c046",
   churchAdmin: "647f3003-aca9-4df3-8959-b594a0bea94a",
   ministryDirectorate: "6b7539c8-9084-46aa-b147-45a8b176bc33",
   pastoralCareDirectorate: "947103f1-299f-4c7b-a52b-4cebc71f6e15",
   HQResidentPastor: "d0bfb9be-b0f4-45c3-9a9f-82d1103dd066",
});
